<template>
  <div class="widget">
    <div class="widget-header">
      {{ $t('menu.invoices') }}
    </div>
    <div class="widget-body">
      <div class="d-flex flex-md-row flex-column align-items-center justify-content-md-between">
      </div>
      <div class="text-center" v-if="loadBtn">
        <span class="loader" ></span>
      </div>
      <table class="table table-striped first-td-padding">
        <thead>
        <tr>
          <td>{{$t('invoice.ID')}}</td>
          <td>{{$t('invoice.Date')}}</td>
          <td>{{$t('invoice.Value')}}</td>
          <td>{{$t('invoice.Actions')}}</td>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in invoices" :id="key" :key="key">
          <td>{{item.id}}</td>
          <td>{{ formatDate(item.date) }}</td>
          <td>{{$t(item.currencyprefix)}}{{$t(item.total)}}</td>
          <td v-if="item.status === 'Unpaid'"><a href="#" @click="getInvoiceLink(item.id)">{{$t('invoice.View')}}</a></td>
          <td v-else>{{$t('invoice.Paid')}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import {getAxios} from 'services/ajax'

  export default {
    data() {
      return {
        invoices: [],
        loadBtn: false
      }
    },
    mounted() {
      this.loadBtn = true

      getAxios().get('/invoices')
        .then(response => {
          this.invoices = response.data.WhmcsGetInvoices.data.invoices.invoice
        })
        .catch(err => {
          if (err.response) {
            console.log(err)
          }
        })
        .finally(() => {
          this.loadBtn = false
        });
    },
    computed: {
      currentLocale() {
        return this.$i18n.locale;
      },
      formattedDate() {
        return this.formatDate(this.currentDate);
      }
    },
    watch: {
      currentLocale(newLocale) {
        // Quando o idioma é alterado, você pode atualizar a data formatada
        this.formattedDate = this.formatDate(this.currentDate);
      }
    },
    methods: {
      formatDate(date) {
        date = new Date(date)
        // Obtém o idioma atual do i18n
        const currentLocale = this.$i18n.locale;

        // Formatos de data para diferentes idiomas
        const dateFormats = {
          'pt-BR': 'dd/MM/yyyy',
          'en-US': 'MM/dd/yyyy'
          // Adicione mais formatos de data conforme necessário
        };

        // Formata a data com base no idioma atual
        return date.toLocaleDateString(currentLocale, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
      },
      getInvoiceLink(id) {
        this.loadBtn = true

        const formData = new FormData()

        formData.append('destination', `viewinvoice.php?id=${id}`)

        getAxios().post('/sso', formData)
          .then(response => {
            window.open(response.data.WhmcsAutoLoginClient.data.redirect_url, '_blank');
          })
          .catch(err => {
            if (err.response) {
              console.log(err)
            }
          })
          .finally(() => {
            this.loadBtn = false
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Invoices/Pages/Invoices.vue